// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_entries_with_invalid_email_addresses_were_removed_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entries with invalid email addresses were removed.`)
};

const en_us2_entries_with_invalid_email_addresses_were_removed_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entries with invalid email addresses were removed.`)
};

const de_de2_entries_with_invalid_email_addresses_were_removed_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einträge mit ungültigen E-Mail-Adressen wurden entfernt.`)
};

const en_entries_with_invalid_email_addresses_were_removed_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entries with invalid email addresses were removed.`)
};

const de_entries_with_invalid_email_addresses_were_removed_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einträge mit ungültigen E-Mail-Adressen wurden entfernt.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const entries_with_invalid_email_addresses_were_removed_1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.entries_with_invalid_email_addresses_were_removed_1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("entries_with_invalid_email_addresses_were_removed_1", locale)
	if (locale === "en-GB") return en_gb2_entries_with_invalid_email_addresses_were_removed_1(inputs)
	if (locale === "en-US") return en_us2_entries_with_invalid_email_addresses_were_removed_1(inputs)
	if (locale === "de-DE") return de_de2_entries_with_invalid_email_addresses_were_removed_1(inputs)
	if (locale === "en") return en_entries_with_invalid_email_addresses_were_removed_1(inputs)
	return de_entries_with_invalid_email_addresses_were_removed_1(inputs)
};
export { entries_with_invalid_email_addresses_were_removed_1 as "Entries with invalid email addresses were removed." }